import { createSelector } from 'reselect';
import { getState } from '../rootSelector';
import { getSelectedSegmentId } from '../selectedSegmentId/selectors';
import { getSelectedSegmentRows } from '../seatMap/selectors';
import { getSeatPrice } from '../../../../../SeatMap/utils';
export const getSelectedSeatsState = createSelector(getState, state => state.selectedSeats);
export const getIsAnySeatSelected = createSelector(getSelectedSeatsState, seats => !!Object.keys(seats).length);
export const getSelectedSeatsBySelectedSegmentId = createSelector(getSelectedSeatsState, getSelectedSegmentId, (selectedSeats, selectedSegmentId) => { var _a; return (_a = selectedSeats[selectedSegmentId]) !== null && _a !== void 0 ? _a : {}; });
export const getSelectedSeatsWithPricesBySelectedSegmentId = createSelector(getSelectedSeatsBySelectedSegmentId, getSelectedSegmentRows, (selectedSeats, selectedSegmentRows) => {
    const seatsWithPrice = {};
    // Создаем карту для быстрого поиска мест
    const seatMap = new Map();
    selectedSegmentRows.forEach(row => {
        var _a;
        (_a = row.seats) === null || _a === void 0 ? void 0 : _a.forEach(seat => {
            seatMap.set(seat.number, seat);
        });
    });
    Object.entries(selectedSeats).forEach(([passengerId, seats]) => {
        if (seats === null || seats === void 0 ? void 0 : seats.length) {
            seatsWithPrice[passengerId] = seats.map(selectedSeat => {
                const seatNumber = `${selectedSeat.row}${selectedSeat.letter}`;
                const seatOnSegment = seatMap.get(seatNumber);
                return Object.assign(Object.assign({}, selectedSeat), { price: getSeatPrice(seatOnSegment) });
            });
        }
    });
    return seatsWithPrice;
});
export const getSelectedSeats = createSelector(getSelectedSeatsState, selectedSeats => {
    var _a, _b, _c;
    const result = [];
    if ((_a = Object.keys(selectedSeats)) === null || _a === void 0 ? void 0 : _a.length) {
        for (const segmentId in selectedSeats) {
            for (const passengerId in selectedSeats[segmentId]) {
                const seats = (_c = (_b = selectedSeats[segmentId]) === null || _b === void 0 ? void 0 : _b[passengerId]) !== null && _c !== void 0 ? _c : [];
                if (seats.length) {
                    result.push(...seats);
                }
            }
        }
    }
    return result;
});
export const getSelectedSeatsArrayBySelectedSegmentId = createSelector(getSelectedSeatsBySelectedSegmentId, selectedSeatsBySelectedSegmentId => {
    var _a;
    if (!((_a = Object.keys(selectedSeatsBySelectedSegmentId)) === null || _a === void 0 ? void 0 : _a.length)) {
        return [];
    }
    const selectedSeatNumbers = [];
    for (const passengerId in selectedSeatsBySelectedSegmentId) {
        const selectedSeats = selectedSeatsBySelectedSegmentId[passengerId];
        if (selectedSeats === null || selectedSeats === void 0 ? void 0 : selectedSeats.length) {
            selectedSeatNumbers.push(...selectedSeats);
        }
    }
    return selectedSeatNumbers;
});
export const getSelectedSeatBySeatNumber = (number) => createSelector(getSelectedSeatsArrayBySelectedSegmentId, selectedSeatsArrayBySelectedSegmentId => selectedSeatsArrayBySelectedSegmentId.find(selectedSeat => `${selectedSeat.row}${selectedSeat.letter}` === number));
